/**
 * useExportEltJobs Hook
 *
 * React Query mutation hook for exporting ELT jobs.
 */

import { useMutation } from '@tanstack/react-query';
import { eltJobService } from '../../../api/elt-job.service';
import type { EltJobExportResponse } from '../../../types/elt-job.types';
import { getErrorMessage } from '../../../lib/utils/errors';

interface UseExportEltJobsOptions {
  onSuccess?: (data: EltJobExportResponse) => void;
  onError?: (error: string) => void;
}

export function useExportEltJobs(tenantId: string, options?: UseExportEltJobsOptions) {
  return useMutation<EltJobExportResponse, Error, string[] | undefined>({
    mutationFn: (eltJobIds?: string[]) =>
      eltJobService.exportEltJobs(tenantId, eltJobIds),
    onSuccess: (data) => {
      options?.onSuccess?.(data);
    },
    onError: (error) => {
      options?.onError?.(getErrorMessage(error));
    },
  });
}
